<template>
	<template v-if="!item.temporary_unavailable && item.type != 'configurable'">
		<template v-if="item.is_available">
			<div v-if="mode != 'fixedBar' && item.show_r1_air_conditioning_reverse_tax_info" class="cd-r1-info">
				<BaseCmsLabel code="notification" tag="span" />
				<BaseCmsLabel code="r1_air_conditioning_reverse_tax_info" />
			</div>

			<div class="add-to-cart-container" :class="{'fixed-bar': mode == 'fixedBar'}">
				<CatalogWidgetSetCompare :item="item" mode="catalogDetail" />

				<template v-if="item.configurable_product_id && item.type_config">
					<template v-for="(varAddToCart, key) in item.type_config" :key="key">
						<BaseWebshopAddToCart v-slot="{onAddToCart, loading}" v-if="item.is_available" @addedToCart="addedToCart" :data="{modalData: item, shopping_cart_code: varAddToCart.shopping_cart_code, quantity: 1}">
							<button
								v-if="creation == true || (item?.xxx && xxxVisibility == true)"
								class="btn btn-green cd-btn-add"
								:class="{'disabled': loading}"
								@click="item?.xxx && xxxVisibility == true ? verificationXXX('addToCart', {shopping_cart_code: item.shopping_cart_code, quantity: 1}) : flyoutOrderInProgressInfo()">
								<span v-if="item.status == 5">{{ labels.get('cd_add_to_shopping_cart_preorder') }}</span>
								<span v-else>{{ labels.get('cd_add_to_shopping_cart') }}</span>
							</button>
							<button v-else-if="advancedItem && advancedItem == key" class="btn btn-green cd-btn-add" :class="{'disabled': loading}" @click="onAddToCart()">
								<span v-if="item.status == 5">{{ labels.get('cd_add_to_shopping_cart_preorder') }}</span>
								<span v-else>{{ labels.get('cd_add_to_shopping_cart') }}</span>
							</button>
						</BaseWebshopAddToCart>
					</template>
				</template>
				<template v-else>
					<BaseWebshopAddToCart v-slot="{onAddToCart, loading}" v-if="item.is_available" @addedToCart="addedToCart" :data="{modalData: item, shopping_cart_code: item.shopping_cart_code, quantity: 1, services: selectedServices}">
						<div
							v-if="creation == true || (item?.xxx && xxxVisibility == true)"
							class="btn btn-green cd-btn-add"
							:class="{'disabled': loading}"
							@click="item?.xxx && xxxVisibility == true ? verificationXXX('addToCart', {shopping_cart_code: item.shopping_cart_code, quantity: 1}) : flyoutOrderInProgressInfo()">
							<span v-if="item.status == 5">{{ labels.get('cd_add_to_shopping_cart_preorder') }}</span>
							<span v-else>{{ labels.get('cd_add_to_shopping_cart') }}</span>
						</div>
						<div v-else class="btn btn-green cd-btn-add" :class="{'disabled': loading}" @click="onAddToCart()">
							<span v-if="item.status == 5">{{ labels.get('cd_add_to_shopping_cart_preorder') }}</span>
							<span v-else>{{ labels.get('cd_add_to_shopping_cart') }}</span>
						</div>
					</BaseWebshopAddToCart>
				</template>
			</div>
		</template>
		<template v-else>
			<template v-if="mode == 'fixedBar'">
				<div class="add-to-cart-container" :class="{'fixed-bar': mode == 'fixedBar'}">
					<CatalogWidgetSetCompare :item="item" mode="catalogDetail" />
				</div>
			</template>
			<div v-else class="add-to-cart-container">
				<template v-if="item.feedback_notification_widget">
					<FeedbackNotificationForm :itemStatus="item.status" />
				</template>
				<div class="cd-compare-container-unavailable">
					<CatalogWidgetSetCompare :item="item" mode="catalogDetail" />
				</div>
			</div>
		</template>
	</template>
</template>

<script setup>
	const labels = useLabels();
	const {bus} = useEventBus();
	const props = defineProps(['item', 'mode', 'advancedItem']);
	let selectedServices = ref(null);
	const { creation } = useCheckout();
	const gtm = useGtmBB();
	const webshop = useWebshop();

	async function addedToCart(value) {
		if(value?.status?.success) {
			const cart = await webshop.getCartData();
			let matchFound = false;

			cart?.parcels?.forEach(parcel => {
				if (matchFound) return;
				parcel?.items?.forEach(data => {
					if (matchFound) return;
					// Check if gtmData is not already assigned

					const matchedProduct = value?.products?.find(product => product?.shopping_cart_code === data?.shopping_cart_code);
					if (matchedProduct) {
						matchFound = true;
						gtm.addProduct({'product': data});
					}
				});
			});
		}
	}

	watch(
		() => bus.value,
		(newValue) => {
			if (newValue.event === 'servicesSelected') {
				selectedServices.value = newValue.data.selectedItems;
			}
		}
	);

	//flyout order in progress info
	const {emit} = useEventBus();
	function flyoutOrderInProgressInfo() {
		document.body.classList.add('flyout-page', 'cd-flyout-active');
		emit('flyoutUpdate', {'flyout_title': labels.get('order_in_creation_flyout_title'), 'flyout_content': labels.get('order_in_creation_flyout_content')});
	}

	//XXX verification
	let xxxVisibility = ref(false);
	function verificationXXX(title, value) {
		emit('xxx', {'title': title, 'value': value});
	}

	function hasCookie(cookieName) {
		if (typeof document !== 'undefined') {
			const cookies = document.cookie.split(';');
			for (let i = 0; i < cookies.length; i++) {
				const cookie = cookies[i].trim();
				if (cookie.startsWith(cookieName + '=')) {
					xxxVisibility.value = false;
					return true;
				} else {
					xxxVisibility.value = true;
				}
			}
		}
		return false;
	}

	onMounted(() => {
		hasCookie('xxx_verification');
	});

	watch(
		() => bus?.value,
		() => {
			if(bus.value?.event == 'xxx_verificated') {
				hasCookie('xxx_verification');
				xxxVisibility.value = false;
			}
		}
	);
</script>

<style lang="less" scoped>
	.cd-r1-info{
		font-size: 16px; line-height: 1.4; margin: 20px 0 0;
		span{display: block; font-size: 18px; font-weight: 600; padding-bottom: 6px;}
		p{padding-bottom: 0;}
		a{
			color: @blue; text-decoration: underline; text-decoration-color: @blue;
			&:hover{text-decoration: none;}
		}

		@media (max-width: @t){
			font-size: 14px;
			span{font-size: 16px;}
			a:hover{text-decoration: underline;}
		}
		@media (max-width: @m){
			font-size: 12px; margin: 15px 0 0;
			span{font-size: 14px; padding-bottom: 4px;}
		}
	}

	.add-to-cart-container{
		display: flex; align-items: flex-end; margin-top: 15px;
		&.hidden{height: 0; opacity: 0; margin: 0;}
		.add-to-cart-container-var{display: flex; align-items: flex-end; flex-grow: 1;}

		@media (max-width: @m){position: relative;}
	}
	.cd-btn-add{
		height: 60px; flex-grow: 1; cursor: pointer;
		&.disabled{
			pointer-events: none;
			span:before{content: ""; width: 34px; height: 34px; background: url(assets/images/loader.svg) no-repeat center; background-size: 34px; top: -5px; z-index: 1;}
		}
		span{
			position: relative; padding-left: 40px;
			&:before{.icon-cart(); font: 26px/1 @fonti; color: @white; position: absolute; left: 0; top: -1px;}
		}

		@media (max-width: @ms){
			height: 54px; margin-left: 64px; font-size: 16px;
			&.disabled span:before{width: 29px; height: 29px; background: url(assets/images/loader.svg) no-repeat center; background-size: 29px; top: -3px;}
			span{
				padding-left: 33px;
				&:before{font-size: 22px;}
			}
		}
	}
	.add-to-cart-disabled{
		display: none; cursor: default;
		span{
			padding: 0!important;
			&:before{content: none;}
		}
		&:hover{border-color: @borderColor!important;}

		@media (max-width: @m){margin-right: 0;}
	}

	.cd-compare-container-unavailable{
		margin-left: 10px;
		:deep(.cd-btn-compare-container){margin: 0 0 19px;}

		@media (max-width: @ms){
			:deep(.cd-btn-compare-container){margin: 0;}
		}
	}

	.fixed-bar{
		align-items: center; margin: 0 0 0 30px; order: 4;
		&.hidden{height: unset; margin: 0 0 0 30px; opacity: 1;}

		.cd-btn-add{
			width: 90px; height: 90px; flex-shrink: 0; flex-grow: unset; padding: 0; margin: 0 0 0 -1px; z-index: 1; .transition(none);
			&:before{.icon-cart(); font: 26px/26px @fonti; color: @white; position: absolute;}
			span{display: none;}
			&.disabled{
				pointer-events: none; font-size: 0;
				&:before{content: ""; width: 40px; height: 40px; background: url(assets/images/loader.svg) no-repeat center; background-size: 40px; z-index: 1;}
			}
		}
		:deep(.cd-btn-compare-container){margin: 0;}
		:deep(.cp-compare){
			width: 90px; height: 90px; flex-shrink: 0; flex-grow: unset; padding: 0; border: none; border-left: 1px solid @borderColor; border-right: 1px solid @borderColor;
			@media (min-width: @t){
				&:hover{
					&:before{opacity: 1;}
					&:after{color: @white;}
				}
			}
		}
		.cd-compare-info{
			top: unset; bottom: calc(~"100% - -10px"); left: 50%!important; right: unset; transform: translateX(-50%);
			&:after{top: unset; bottom: -4px; left: 50%!important; right: unset; transform: translateX(-50%) rotate(45deg);}
		}
		.add-to-cart-disabled{
			display: none; border-top: none; border-bottom: none; cursor: pointer;
			&:before{color: @textColor; z-index: 11;}
			&:after{.pseudo(auto,auto); background: linear-gradient(315deg, #0078B4 0%, #0050A0 100%); left: 0; right: 0; top: 0; bottom: 0; opacity: 0; z-index: -1; .transition(opacity);}
			&:hover{
				&:before{color: @white;}
				&:after{opacity: 1; z-index: 1;}
			}
		}

		@media (max-width: @m){
			flex-grow: 1; max-width: 50%; margin: 0;
			:deep(.cd-btn-compare-container){display: none!important;}
			.cd-btn-add{
				width: 100%; height: 50px; margin: 0; padding: 0 15px; font-size: 15px;
				&:before{content: none;}
				:deep(span){
					display: inline-block; padding: 0;
					&:before{content: none;}
				}
				&.disabled{
					pointer-events: none; font-size: 0;
					&:before{content: ""; width: 40px; height: 40px; background: url(assets/images/loader.svg) no-repeat center; background-size: 40px; z-index: 1;}
				}
			}
			.add-to-cart-disabled{border-top: 1px solid @borderColor; border-bottom: 1px solid @borderColor;}
		}
	}
</style>
